import React, { useState, useEffect } from "react";
import {
  Card,
  CardHeader,
  Typography,
  Grid,
  Divider,
  Dialog,
  DialogContent,
  IconButton,
} from "@mui/material";
import { ArrowBackIos, ArrowForwardIos, Close } from "@mui/icons-material";

const ProductDetailsImages = ({ detailsImages, productName }) => {
  const [open, setOpen] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(0);

  const handleOpen = (index) => {
    setSelectedIndex(index);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handlePrev = () => {
    setSelectedIndex((prevIndex) =>
      prevIndex === 0 ? detailsImages.length - 1 : prevIndex - 1
    );
  };

  const handleNext = () => {
    setSelectedIndex((prevIndex) =>
      prevIndex === detailsImages.length - 1 ? 0 : prevIndex + 1
    );
  };

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (open) {
        if (event.key === "ArrowLeft") {
          handlePrev();
        } else if (event.key === "ArrowRight") {
          handleNext();
        } else if (event.key === "Escape") {
          handleClose();
        }
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [open]);

  return (
    <>
      <Card elevation={3} sx={{ padding: 3, maxWidth: 1200 }}>
        <CardHeader
          title={
            <Typography
              variant="h5"
              fontWeight="bold"
              align="center"
              sx={{ mb: 2 }}
            >
              Product Detail Media
            </Typography>
          }
        />
        <Divider sx={{ mb: 2 }} />
        <Grid container spacing={2}>
          {detailsImages.length > 0 ? (
            detailsImages.map((detail, index) => {
              const mediaSrc = `https://cms-test.my-ogawa.com/backend/uploads/bodyfriend/displayImages/${detail.details_image_path}`;

              return (
                <Grid item xs={6} sm={4} md={3} key={detail.id || index}>
                  {detail.details_type === "image" ? (
                    <img
                      src={mediaSrc}
                      alt={`Detail ${productName}`}
                      style={{
                        width: "100%",
                        height: "250px",
                        objectFit: "cover",
                        borderRadius: "8px",
                        boxShadow: "0px 2px 4px rgba(0,0,0,0.2)",
                        cursor: "pointer",
                        transition: "transform 0.3s",
                      }}
                      onClick={() => handleOpen(index)}
                      onMouseOver={(e) =>
                        (e.target.style.transform = "scale(1.05)")
                      }
                      onMouseOut={(e) =>
                        (e.target.style.transform = "scale(1)")
                      }
                    />
                  ) : (
                    <video
                      src={mediaSrc}
                      autoPlay
                      controls
                      muted
                      style={{
                        width: "100%",
                        height: "250px",
                        borderRadius: "8px",
                        boxShadow: "0px 2px 4px rgba(0,0,0,0.2)",
                        cursor: "pointer",
                      }}
                      onClick={() => handleOpen(index)}
                    />
                  )}
                </Grid>
              );
            })
          ) : (
            <Typography color="textSecondary" align="center">
              No media available
            </Typography>
          )}
        </Grid>
      </Card>

      {/* Enlarged Media Dialog */}
      <Dialog open={open} onClose={handleClose} maxWidth="xl" fullScreen>
        <DialogContent
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            position: "relative",
            bgcolor: "rgba(255, 255, 255, 0.9)",
          }}
        >
          {/* Close Button */}
          <IconButton
            onClick={handleClose}
            sx={{
              position: "absolute",
              top: 20,
              right: 20,
              color: "white",
              background: "rgba(0,0,0,0.6)",
              "&:hover": { background: "rgba(0,0,0,0.8)" },
            }}
          >
            <Close fontSize="large" />
          </IconButton>

          {/* Left Arrow */}
          <IconButton
            onClick={handlePrev}
            sx={{
              position: "absolute",
              left: 30,
              color: "white",
              background: "rgba(0,0,0,0.6)",
              "&:hover": { background: "rgba(0,0,0,0.8)" },
            }}
          >
            <ArrowBackIos fontSize="large" />
          </IconButton>

          {/* Enlarged Media */}
          <div
            style={{
              width: "80%",
              maxHeight: "90vh",
              display: "flex",
              justifyContent: "center",
              overflow: "hidden",
            }}
          >
            {detailsImages.length > 0 && detailsImages[selectedIndex] ? (
              detailsImages[selectedIndex].details_type === "image" ? (
                <img
                  src={`https://cms-test.my-ogawa.com/backend/uploads/bodyfriend/displayImages/${detailsImages[selectedIndex].details_image_path}`}
                  alt={`Detail ${productName}`}
                  style={{
                    width: "100%",
                    height: "auto",
                    objectFit: "contain",
                    transition: "transform 0.3s",
                  }}
                />
              ) : (
                <video
                  src={`https://cms-test.my-ogawa.com/backend/uploads/bodyfriend/displayImages/${detailsImages[selectedIndex].details_image_path}`}
                  controls
                  autoPlay
                  style={{
                    width: "100%",
                    height: "auto",
                    objectFit: "contain",
                  }}
                />
              )
            ) : (
              <Typography color="textSecondary">No media available</Typography>
            )}
          </div>

          {/* Right Arrow */}
          <IconButton
            onClick={handleNext}
            sx={{
              position: "absolute",
              right: 30,
              color: "white",
              background: "rgba(0,0,0,0.6)",
              "&:hover": { background: "rgba(0,0,0,0.8)" },
            }}
          >
            <ArrowForwardIos fontSize="large" />
          </IconButton>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default ProductDetailsImages;
